var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyCategory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.1,
    height: 86.481,
    viewBox: "0 0 87.1 86.481",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55183",
    "data-name": "Group 55183",
    transform: "translate(16952.887 1075.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-menu-2151143",
    transform: "translate(-16952.887 -1075.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34179",
    "data-name": "Path 34179",
    d: "M599.193,318.369a.935.935,0,0,0-.366-.849,1.163,1.163,0,0,0-.744-.376,1.665,1.665,0,0,0-.838.376,1.156,1.156,0,0,0-.283.849,1.059,1.059,0,0,0,.283.742,1.66,1.66,0,0,0,.838.379,1.159,1.159,0,0,0,.744-.379A.864.864,0,0,0,599.193,318.369Zm.839-1.981a3.092,3.092,0,0,1,.742,1.98,2.5,2.5,0,0,1-.837,1.863,2.64,2.64,0,0,1-1.854.849,3.112,3.112,0,0,1-1.959-.849,2.974,2.974,0,0,1-.733-1.863,2.9,2.9,0,0,1,.733-1.98h.094a2.6,2.6,0,0,1,1.865-.744,2.553,2.553,0,0,1,1.854.744Z",
    transform: "translate(-513.675 -266.86)",
    fill: "#3a3a3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34180",
    "data-name": "Path 34180",
    d: "M497.661,59.024a.892.892,0,0,1,.273,1.121c-.1.094-.178.188-.273.283l-2.881,1.686a.745.745,0,0,1-1.026-.283.812.812,0,0,1,.283-1.12l1.665-.943-1.665-1.027a.7.7,0,0,1-.283-1.037.684.684,0,0,1,1.026-.283Z",
    transform: "translate(-423.515 -50.314)",
    fill: "#3a3a3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34181",
    "data-name": "Path 34181",
    d: "M413.958,533.9a.834.834,0,0,1,.827.848.818.818,0,0,1-.827.745h-4.085a.732.732,0,0,1-.742-.745.762.762,0,0,1,.742-.848Z",
    transform: "translate(-356.384 -451.169)",
    fill: "#3a3a3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34182",
    "data-name": "Path 34182",
    d: "M370.882,547.77a.812.812,0,0,1,.755.755.829.829,0,0,1-.755.838h-8.819a.828.828,0,0,1-.744-.838.811.811,0,0,1,.744-.755Z",
    transform: "translate(-316.009 -462.882)",
    fill: "#3a3a3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34186",
    "data-name": "Path 34186",
    d: "M186.284,15.224a.885.885,0,0,1-.555,1.037l-1.393.377a.892.892,0,0,1-1.027-.566.962.962,0,0,1,.566-1.037l1.393-.366A.928.928,0,0,1,186.284,15.224Z",
    transform: "translate(-165.672 -12.682)",
    fill: "#3a3a3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34187",
    "data-name": "Path 34187",
    d: "M179.322,29.909a.828.828,0,0,1-.555.932.8.8,0,0,1-1.027-.555l-.367-1.414a.827.827,0,0,1,.555-.932.942.942,0,0,1,1.027.555Z",
    transform: "translate(-160.658 -23.888)",
    fill: "#3a3a3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34188",
    "data-name": "Path 34188",
    d: "M172.628,3.883a.817.817,0,0,1-.555,1.027.773.773,0,0,1-.933-.565l-.377-1.309a.852.852,0,0,1,.566-1.027.82.82,0,0,1,.922.555Z",
    transform: "translate(-155.074 -1.991)",
    fill: "#3a3a3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34189",
    "data-name": "Path 34189",
    d: "M159.151,23.529a.771.771,0,0,1-.367-1.5l1.383-.377c.471-.189.838.094,1.026.566a.821.821,0,0,1-.555.932Z",
    transform: "translate(-144.478 -18.546)",
    fill: "#3a3a3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34191",
    "data-name": "Path 34191",
    d: "M94.6,431.419c.084-.094.084-.19.084-.377a.374.374,0,0,0-.084-.283.713.713,0,0,0-.377-.188.468.468,0,0,0-.366.188c-.094.094-.188.188-.188.283a.492.492,0,0,0,.188.377.469.469,0,0,0,.366.189A.709.709,0,0,0,94.6,431.419Zm1.111-1.781a1.929,1.929,0,0,1,.555,1.4,1.982,1.982,0,0,1-.555,1.5,2,2,0,0,1-2.975,0,1.943,1.943,0,0,1,0-2.9,2.006,2.006,0,0,1,2.975,0Z",
    transform: "translate(-88.654 -362.567)",
    fill: "#3a3a3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34192",
    "data-name": "Path 34192",
    d: "M90.613,166.69l.461,1.414-1.487.461-.461-1.4Z",
    transform: "translate(-86.151 -141.073)",
    fill: "#3a3a3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34194",
    "data-name": "Path 34194",
    d: "M84.014,178.75l.377,1.4-1.487.471-.377-1.4Z",
    transform: "translate(-80.579 -151.258)",
    fill: "#3a3a3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34195",
    "data-name": "Path 34195",
    d: "M78.183,160.7l.367,1.4-1.487.471-.461-1.508Z",
    transform: "translate(-75.575 -136.015)",
    fill: "#3a3a3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34196",
    "data-name": "Path 34196",
    d: "M71.487,172.75l.461,1.4-1.572.471-.377-1.5Z",
    transform: "translate(-70 -146.191)",
    fill: "#3a3a3c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_34280",
    "data-name": "Path 34280",
    d: "M202.517,21.94h-.878V18.968a5.215,5.215,0,0,0-2.026-4.12,5.067,5.067,0,0,0-4.458-.946l-28.84,7.43A5.211,5.211,0,0,0,162.4,26.4V72.732a5.2,5.2,0,0,0,5.2,5.2h34.987a5.247,5.247,0,0,0,5.2-5.2V27.141a5.351,5.351,0,0,0-5.268-5.2Zm-6.484-4.323a1.275,1.275,0,0,1,1.215.27,1.41,1.41,0,0,1,.54,1.081V21.94H179.283Zm7.9,55.114a1.427,1.427,0,0,1-1.419,1.419H167.53a1.427,1.427,0,0,1-1.419-1.419V26.4a1.993,1.993,0,0,1,.135-.676h36.2a1.427,1.427,0,0,1,1.419,1.419V72.732Z",
    transform: "translate(-17093.846 -1078.78)",
    fill: "#3a3a3c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_55184",
    "data-name": "Group 55184",
    transform: "translate(-16921.24 -1039.983)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M18.352,20.612a1.292,1.292,0,0,1-1.018-.477c-.442-.552-.989-1.348-1.568-2.191-.714-1.039-1.522-2.216-2.316-3.2A7.778,7.778,0,0,0,11.169,12.6c-.255-.124-.588-.245-.973-.384l-.007,0-.026-.009-.265-.1,1.634-1.63,7.7,7.742a1.457,1.457,0,0,1,.284,1.713l0,0a1.251,1.251,0,0,1-.2.279A1.37,1.37,0,0,1,18.352,20.612ZM7.115,10.8h0A11.97,11.97,0,0,1,4.963,9.085,30.856,30.856,0,0,1,2.183,5.923,14.962,14.962,0,0,1,.64,3.451a6.55,6.55,0,0,1-.6-1.808A2.643,2.643,0,0,1,.091.471.092.092,0,0,1,.1.452l0,0a.219.219,0,0,0,.01-.02A.684.684,0,0,1,.765,0a.839.839,0,0,1,.6.256L9.553,8.491,7.115,10.8Z",
    transform: "translate(2.743 1.064)",
    fill: "#3a3a3c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32338",
    "data-name": "Path 32338",
    d: "M4.658,0,4.6,8.774H3.875L3.714,0H3.341L3.168,8.774H2.447L2.29,0H1.95L1.769,8.774H1.048L.969,0H.622A68.289,68.289,0,0,0,0,8c0,2.484.507,2.455,1.979,3.042L1.436,26.56a1.458,1.458,0,0,0,1.128,1.458v.01a1.2,1.2,0,0,0,.243.027,1.442,1.442,0,0,0,1.371-1.5L3.636,11.047C5.109,10.459,5.615,10.489,5.615,8a67.908,67.908,0,0,0-.63-8Z",
    transform: "translate(19.838 0) rotate(45)",
    fill: "#3a3a3c"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCategory);
export default __webpack_public_path__ + "static/media/emptyCategory.2e58e09589388b00f2abda7e51a20e0f.svg";
export { ForwardRef as ReactComponent };